"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetReceivablesQuery = exports.ReceivableSortField = void 0;
const typebox_1 = require("@sinclair/typebox");
/**
 * Unified billing (v2) receivable list query. Standalone — not composed from the v1 query, whose
 * per-brand id filters (`orderID`, `commercialSubscriptionID`, `commercialBillingActivityID`,
 * `serviceGroupingID`, `productInvoiceGroupingID`, `receivableWithLineItemWithServiceOrderID`) all
 * collapse into `references`, matched against invoice-level references.
 */
/**
 * Sortable columns. An allowlist rather than a free string: an unknown field reaches MikroORM as a
 * property that does not exist and throws, so it is rejected at validation instead. `default` is
 * the v1 sentinel for "no explicit sort" — accepted, and treated as the default ordering.
 */
exports.ReceivableSortField = typebox_1.Type.Union([
    typebox_1.Type.Literal('default'),
    typebox_1.Type.Literal('invoiceDetails.issueDate'),
    typebox_1.Type.Literal('invoiceDetails.dueDate'),
    typebox_1.Type.Literal('invoiceDetails.invoiceNumber'),
    typebox_1.Type.Literal('invoiceDetails.voidDate'),
    typebox_1.Type.Literal('customerName'),
    typebox_1.Type.Literal('customerCompanyName'),
    typebox_1.Type.Literal('customerAccountNumber'),
]);
exports.GetReceivablesQuery = typebox_1.Type.Object({
    customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    /** Comma-separated receivable ids. */
    receivableIDs: typebox_1.Type.Optional(typebox_1.Type.String()),
    invoiceNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    /**
     * Comma-separated `<entityType>:<id>` pairs — the only reference filter. Ids are grouped
     * by type and OR'd together.
     */
    references: typebox_1.Type.Optional(typebox_1.Type.String()),
    /** Comma-separated `InvoiceStatus` values. */
    statuses: typebox_1.Type.Optional(typebox_1.Type.String()),
    syncedWithAccounting: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    issuedBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    issuedAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    dueBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    dueAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    paymentsBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    paymentsAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    /** Defaults: limit 100, offset 0, sort unissued first, then by issue date DESC, ties by creation date DESC. */
    limit: typebox_1.Type.Optional(typebox_1.Type.Number()),
    offset: typebox_1.Type.Optional(typebox_1.Type.Number()),
    sortBy: typebox_1.Type.Optional(exports.ReceivableSortField),
    sortDescending: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    nullsLast: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
}, 
// A retired param name would otherwise be ignored rather than rejected, and this list's filters
// fail open — a dropped `references` widens the query to the hauler's whole book.
{ additionalProperties: false });
//# sourceMappingURL=get-receivables-query.js.map